import { useState } from "react";
import { Button, Card, Input, PasswordStrengthMeter, Stack, guardSubmit, useToast } from "@salesapp/ui";
import { reportSaveBlocked } from "../lib/saveNotice";
import { api, ApiError } from "../lib/api";

export function PasswordSettings() {
  const { show } = useToast();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  async function submit() {
    if (next.length < 12) { setError(reportSaveBlocked(show, "Choose a password of at least 12 characters.")); return; }
    if (next !== confirmation) { setError(reportSaveBlocked(show, "New passwords must match.")); return; }
    setSaving(true); setError("");
    try {
      await api.post("/auth/password", { current_password: current, new_password: next });
      window.location.assign("/login?passwordChanged=1");
    } catch (reason) {
      const message = reason instanceof ApiError && reason.status === 400
        ? reason.message
        : "Password could not be changed. Please try again.";
      setError(reportSaveBlocked(show, message));
      setSaving(false);
    }
  }
  return <Card><h2>Change password</h2>
    <p>Use 12–128 characters. Changing your password signs you out of all sessions.</p>
    <form onSubmit={guardSubmit((event) => { event.preventDefault(); return submit(); })}><Stack gap={4}>
      <Input label="Current password" type="password" autoComplete="current-password" required maxLength={512} value={current} onChange={(event) => setCurrent(event.target.value)} />
      <Input label="New password" type="password" autoComplete="new-password" required minLength={12} maxLength={128} value={next} onChange={(event) => setNext(event.target.value)} />
      <PasswordStrengthMeter password={next} minLength={12} />
      <Input label="Confirm new password" type="password" autoComplete="new-password" required minLength={12} maxLength={128} value={confirmation} onChange={(event) => setConfirmation(event.target.value)} />
      {error && <p role="alert">{error}</p>}
      <Button type="submit" disabled={saving}>{saving ? "Changing password…" : "Change password"}</Button>
    </Stack></form>
  </Card>;
}
